<template
	class="filter"
>
	<div class="container">
		<div class="filter__inner">
			<!-- Use Vue v-for to create <select> with <option> items -->
			<!-- <pre>{{ props.categories }}</pre> -->
			<header class="filter__header">
				<h2>
					<span class="filter__icon">
						<span class="icon icon--filter">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M14.7345 16.3245C13.0686 17.5875 10.9854 18.1709 8.90587 17.957C6.82635 17.743 4.9056 16.7476 3.53181 15.1719C2.15802 13.5962 1.43364 11.5577 1.50507 9.4684C1.5765 7.37912 2.43841 5.39487 3.91662 3.91666C5.39482 2.43846 7.37908 1.57654 9.46835 1.50511C11.5576 1.43368 13.5961 2.15806 15.1718 3.53186C16.7475 4.90565 17.743 6.8264 17.9569 8.90592C18.1709 10.9854 17.5874 13.0686 16.3245 14.7345L20.67 19.08C20.7805 19.183 20.8691 19.3072 20.9306 19.4452C20.9921 19.5832 21.0252 19.7322 21.0278 19.8832C21.0305 20.0343 21.0027 20.1843 20.9461 20.3244C20.8896 20.4645 20.8053 20.5917 20.6985 20.6986C20.5917 20.8054 20.4644 20.8896 20.3244 20.9462C20.1843 21.0028 20.0342 21.0306 19.8832 21.0279C19.7321 21.0252 19.5831 20.9922 19.4451 20.9307C19.3071 20.8692 19.1829 20.7805 19.08 20.67L14.7345 16.3245ZM15.75 9.75C15.75 8.1587 15.1178 6.63258 13.9926 5.50736C12.8674 4.38214 11.3413 3.75 9.74996 3.75C8.15866 3.75 6.63253 4.38214 5.50731 5.50736C4.3821 6.63258 3.74995 8.1587 3.74995 9.75C3.74995 11.3413 4.3821 12.8674 5.50731 13.9926C6.63253 15.1179 8.15866 15.75 9.74996 15.75C11.3413 15.75 12.8674 15.1179 13.9926 13.9926C15.1178 12.8674 15.75 11.3413 15.75 9.75Z"
									:fill="props.color"
								/>
							</svg>
						</span>
					</span>
					{{ props.translations.filterVideos }}
				</h2>
			</header>
			<form
				class="filter__form"
				v-if="props.categories.length && ready"
			>
				<div
					class="form__input"
					v-for="category of props.categories"
					:key="category.id"
				>
					<label
						:for="`filter__${category.name}`"
					>
						{{ category.title }}
					</label>
					<select
						:id="`filter__${category.name}`"
						:name="category.id"
						class="filter__select"
						v-model="terms[category.name]"
					>
						<option value="">
							{{ props.translations.all }}
						</option>
						<option
							v-for="option of category.options"
							:key="option.id"
							:value="option.name"
						>
							{{ option.title }}
						</option>
					</select>
				</div>
				<div
					class="form__input form__input--reset"
					v-if="Object.values(terms).some(term => term !== '')"
				>
					<button
						@click.prevent="resetForm()"
					>
						<span class="icon">
							<svg
								width="24"
								height="24"
								fill="none"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							><path
								d="m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z"
								fill="inherit"
							/></svg>
						</span>
						{{ props.translations.clearSelections }}
					</button>
				</div>
			</form>
		</div>
	</div>
	<section
		class="videos"
		id="videos"
		ref="searchResultsContainer"
	>
		<div class="container">
			<div
				class="videos__inner"
			>
				<ul
					class="videos__list"
					ref="jsCards"
					v-if="filteredVideos[currentPage -1] && filteredVideos[currentPage -1].length"
				>
					<li
						class="videos__item"
						v-for="video of filteredVideos[currentPage - 1]"
						:key="video.id"
					>
						<div
							class="card js-card"
							:style="`border-color: ${video.color};`"
						>
							<div
								v-if="video.image.url"
								class="card__image"
							>
								<img
									class="card__img"
									:src="video.image.url"
									height="video.image.height"
									width="video.image.width"
									alt=""
								>
							</div>
							<div class="card__content">
								<h3 class="card__title">
									<a
										:href="video.url"
										class="card__link"
									>
										{{ video.title }}
									</a>
								</h3>
								<p
									class="card__summary"
									v-if="video.summary.length"
								>
									{{ video.summary }}
								</p>
								<ul
									class="tags__list"
									v-if="video.categories.length"
								>
									<li
										class="tag"
										v-for="category of video.categories"
										:key="category.id"
										:style="`background-color: ${video.color}30;`"
									>
										{{ category.title }}
									</li>
								</ul>
							</div>
						</div>
					</li>
				</ul>
				<!-- No search results -->
				<p
					v-else
					class="no-results"
				>
					{{ props.translations.noResults }}
				</p>
			</div>
		</div>
		<!-- Pagination -->
		<nav
			v-if="filteredVideos.length > 1"
			class="pager"
		>
			<h2 class="sr-only">
				{{ props.translations.selectPage }}
			</h2>
			<ul class="pager__list">
				<li
					v-for="pageNum in filteredVideos.length"
					:key="`page-${pageNum}`"
					class="pager__item"
				>
					<component
						:is="currentPage !== pageNum ? 'button' : 'span'"
						type="button"
						@click="setPage(pageNum, true)"
						:class="[
							'pager__link',
							currentPage === pageNum ? 'pager__current' : null,
						]"
						:aria-selected="currentPage === pageNum"
					>
						{{ pageNum }}
						<span class="sr-only">/ {{ filteredVideos.length }}</span>
					</component>
				</li>
			</ul>
		</nav>
	</section>
</template>

<script setup>

import { ref, computed, onMounted, watch, onUpdated } from 'vue'
import queryString from 'query-string'

const props = defineProps({
	categories: {
		type: [Array],
		required: false,
		default() {
			return []
		},
	},
	videos: {
		type: [Array],
		required: false,
		default() {
			return []
		},
	},
	color: {
		type: String,
		required: false,
		default() {
			return ''
		},
	},
	itemsPerPage: {
		type: [Number],
		required: false,
		default () {
			return 18
		},
	},
	translations: {
		type: Object,
		required: false,
		default() {
			return {
				filterVideos: 'Filter videos',
				all: 'All',
				clearSelections: 'Clear selections',
				noResults: 'Unfortunately, no videos were found with your filter criteria.',
				selectPage: 'Select page:',
			}
		},
	},
})

// Is app ready to run?
const ready = ref(false)

// Search terms
const terms = ref()

// Filtered videos
const filteredVideos = computed(() => {
	if (ready.value === false) return []

	const results = props.videos.filter(item => {
		// Filter by category
		for (const category of props.categories) {
			if (terms.value[category.name] && terms.value[category.name] !== '') {
				if (!item.categories.some(cat => cat.name === terms.value[category.name])) {
					return false
				}
			}
		}

		return true
	})

	// Split into pages
	return Array.from({ length: Math.ceil(results.length / props.itemsPerPage) }, (v, i) =>
		results.slice(i * props.itemsPerPage, i * props.itemsPerPage + props.itemsPerPage)
	)
})

// Search results container element
const searchResultsContainer = ref(null)

// Update query string to contain search terms and page
const updateQueryString = () => {
	const qs = queryString.stringify({
		...terms.value,
		page: currentPage.value !== 1 ? currentPage.value : null,
	}, {
		skipNull: true,
		skipEmptyString: true,
		arrayFormat: 'bracket',
	})

	window.history.replaceState(
		{},
		'',
		qs.length ? `${window.location.pathname}?${qs}` : window.location.pathname
	)
}

// Current page number
const currentPage = ref(1)

// Set page number and optionally focus to the search results
const setPage = (num = null, focusToResults = false) => {
	if (!num || currentPage.value === num) return

	currentPage.value = num
	updateQueryString()

	// Focus to search results container
	if (focusToResults === true && searchResultsContainer.value) {
		searchResultsContainer.value.scrollIntoView({ behavior: 'smooth' })
	}
}

const resetForm = () => {
	terms.value = {}

	props.categories.forEach(category => {
		terms.value[category.name] = ''
	})

	setPage(1)
	updateQueryString()
}

onMounted(() => {
	// Parse query string
	const qs = queryString.parse(location.search, {
		arrayFormat: 'bracket',
	})

	terms.value = {}

	// Iterate categories from props
	props.categories.forEach(category => {
		// If category is defined in query string, set it
		if (qs[category.name]) {
			terms.value[category.name] = qs[category.name]
		} else {
			terms.value[category.name] = ''
		}
	})

	// Set current page
	setPage(qs.page ? parseInt(qs.page) : 1)

	// Mark app as ready to run
	ready.value = true

	// Watch for changes in terms
	watch(() => terms.value, () => {
		updateQueryString()
		setPage(1)
	}, {
		deep: true,
	})
})

onUpdated(() => {
	const jsCards = document.querySelectorAll('.js-card')

	jsCards.forEach(card => {
		let down, up, link = card.querySelector('h3 a')

		card.onmousedown = () => down = +new Date()
		card.onmouseup = () => {
			up = +new Date()
			if ((up - down) < 200) {
				link.click()
			}
		}
	})
})

</script>
